// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__2cU8j","title":"Images45_title__snv89","images":"Images45_images__1p6fW"};